<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header @custom-event="getToken"></Header>
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span><a href="/tw/user/index">我的帳戶</a><span class="space">/</span>協議帳單
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			<!--页面内容-开始-->
			<div class="user_content">
				<div class="user_title">協議帳單</div>
				<div class="user_main_box">
					
					<!--筛选-开始-->
					<div class="head_box">
						<div class="total" style="margin-top: 8px;" v-if="recordTotal>0">共 {{recordTotal}} 條數據</div>
						<!-- <div class="filter">
							<div class="elem">
								<el-select v-model="orderStatus" clearable placeholder="账单状态">
									<el-option
									v-for="item in orderStatusList"
									:key="item.Id"
									:label="item.Title"
									:value="item.Id">
									</el-option>
								</el-select>
							</div>
							<div class="elem" style="width: 250px;">
								<el-input
								  placeholder="请输入账单号"
								  v-model="keyword"
								  maxlength="30"
								  clearable>
								</el-input>
							</div>
							<div class="elem">
								<div class="btn">搜索</div>
							</div>
						</div> -->
					</div>
					<!--筛选-结束-->
					
					
					<!--列表-开始-->
					<div class="items_box">
						<ul class="thead">
							<li class="l1">賬單號</li>
							<li class="l2">賬單標題</li>
							<li class="l3 al_right">總金額</li>
							<li class="l4 al_right">已支付</li>
							<li class="l5">創建時間</li>
							<li class="l6">狀態</li>
							<li class="l7">操作</li>
						</ul>
						
						<!--无数据-->
						<NoData :isShow="noDataIsShow"></NoData>
						
						<ul class="tbody" v-for="(item, index) in orderList" :key="index">
							<li class="l1">{{item.OrderNo}}</li>
							<li class="l2">{{item.Title}}</li>
							<li class="l3 al_right">${{item.PayablePrice}}</li>
							<li class="l4 al_right">${{item.Paid}}</li>
							<li class="l5">{{item.Time}}</li>
							<li class="l6">{{item.StatusText}}</li>
							<li class="l7"><a :href="'/tw/user/protocol_detail?OrderNo='+item.OrderNo" target="_blank">詳情</a></li>
						</ul>
					</div>
					<!--列表-结束-->
					
					<!--分页-开始-->
					<div class="page_ctrl" v-if="this.orderList.length>0 && pageTotal>1">
						<el-pagination layout="prev, pager, next" :total="recordTotal" :current-page="pageIndex"
							:pager-count="5" :page-size="pageSize" :background="true" @current-change="handleCurrentChange">
						</el-pagination>
					</div>
					<!--分页-结束-->
					
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
	import {
		checkToken,
		getProtocol,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	import NoData from '@/components/tw_noData.vue'
	export default {
		name: 'TW_UserProtocol',
		mixins: [mixin],
		components: {
			Header,
			Footer,
			NoData,
		},
		data() {
			return {
				fullscreenLoading: true, //loading状态
				noDataIsShow: false, //无数据缺省
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				pageIndex: 1, 		//页码，默认为1
				pageSize: 10, 		//每页显示条数
				pageTotal: 0, 		//总页数
				recordTotal: 0, 	//总条数
				
				orderList: [],
			}
		},
		created() {
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
					this.getData()
				}
				else				
				{
					this.$router.push({
						path: '/tw/user/login'
					})
				}
			},
			//获取数据
			async getData() {
				this.orderList = []
				this.fullscreenLoading = true
				const { data: res } = await getProtocol(this.language, this.token, this.terminal, this.pageIndex)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					
					if(res.data != null)
					{
						this.orderList = res.data.DataList
						this.pageTotal = res.data.PageTotal
						this.recordTotal = res.data.RecordTotal
						if (res.data.DataList.length > 0) {
							this.noDataIsShow = false
							this.$nextTick(() => {
								window.scrollTo(0, 0);
							});
						} else {
							this.noDataIsShow = true
						}
					}
					else{
						this.noDataIsShow = true
					}
					
				} else {
					this.$message.error(res.errmsg);
				}
			},
			//切换页码
			handleCurrentChange(val) {
				this.pageIndex = val
				this.getData()
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;		
		
		.items_box {
			margin-top: 20px;
			
			.l1 {
				width: 15%;
			}
			.l2 {
				width: 42%;
			}
			.l3 {
				width: 8%;
			}
			.l4 {
				width: 8%;
			}
			.l5 {
				width: 12%;
			}
			.l6 {
				width: 10%;
			}
			.l7 {
				width: 5%;
				text-align: center;
			}
			.al_right {
				text-align: right;
			}
			
			ul.thead {
				display: flex;
				align-items: center;
				background-color: #F7F7F7;
				
				li {
					font-weight: 500;
					height: 46px;
					line-height: 46px;
					font-size: 13px;
					padding: 0 12px;
					box-sizing: border-box;
				}
			}
			ul.tbody {
				display: flex;
				align-items: center;
				background-color: #fff;
				border-bottom: #e4e4e4 solid 1px;
				
				li {
					line-height: 160%;
					font-size: 13px;
					padding: 10px 12px;
					box-sizing: border-box;
				}
				a {
					color: #008768;
					text-decoration: underline;
				}
				a:hover {
					color: #000;
				}
			}
			ul.tbody:hover {
				background-color: #F5F7FA;
			}
		}
	}
</style>